import React, { useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added this import

function AddProvider() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [form, setForm] = useState({
    name: '',
    email: '',
    services: '',
    cities: ''
  });
  const [message, setMessage] = useState('');

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === 'fixxzap2025') {
      setIsAuthenticated(true);
      setMessage('');
    } else {
      setMessage('Invalid password');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const servicesArray = form.services.split(',').map(s => s.trim());
      const citiesArray = form.cities.split(',').map(c => c.trim());
      const response = await axios.post('/api/admin/add-provider', {
        name: form.name,
        email: form.email,
        services: servicesArray,
        cities: citiesArray,
        password: 'fixxzap2025'
      });
      setMessage(response.data.message);
      setForm({ name: '', email: '', services: '', cities: '' });
    } catch (error) {
      setMessage(error.response?.data?.message || 'Error adding provider');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="container-fluid mt-5">
        <Helmet>
          <title>Fixxzap - Admin Add Provider</title>
        </Helmet>
        <div className="card p-4 shadow-sm mx-auto" style={{ maxWidth: '400px' }}>
          <h2 className="text-center mb-4">Admin Login</h2>
          <form onSubmit={handlePasswordSubmit}>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
              />
            </div>
            {message && <p className="text-danger text-center">{message}</p>}
            <button type="submit" className="btn btn-primary w-100">Login</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-5">
      <Helmet>
        <title>Fixxzap - Admin Add Provider</title>
      </Helmet>
      <div className="row">
        <div className="col-12 text-center mb-4">
          <h2>Manually Add Provider</h2>
          <Link to="/admin/review" className="btn btn-link">Back to Admin Review</Link>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mx-auto">
          <div className="card p-4 shadow-sm">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  placeholder="Provider Name"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  placeholder="Provider Email"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Services (comma-separated)</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.services}
                  onChange={e => setForm({ ...form, services: e.target.value })}
                  placeholder="e.g., Plumbing, Electrical"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Cities (comma-separated)</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.cities}
                  onChange={e => setForm({ ...form, cities: e.target.value })}
                  placeholder="e.g., Cape Town, Durban"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100">Add Provider</button>
            </form>
            {message && <p className={`mt-3 text-center ${message.includes('Error') ? 'text-danger' : 'text-success'}`}>{message}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProvider;
